<template>
    <!-- 规则排课 -->
    <el-form :model="form" ref="form" :rules="rules">
        <div class="formItemBox mb-15">
            <el-form-item label="班级名称" prop="classcoursecode">
                <SelectPage v-if="!disabled" ref="SelectPage" :listLoading="false" @getSelectValue="getSelectClass" label="name" value="code" :list="classOptions" :isMultiple="false" :paginationOption="paginationOptionClass" />
                <el-input v-else :disabled="disabled" v-model="defaultChoiceValue" maxlength="100"></el-input>
            </el-form-item>
        </div>
        <div class="formItemBox mb-15">
            <el-form-item label="对应课程" prop="classcoursecode">
                <SelectPage v-if="!courseDisabled" ref="SelectPageCourse" :listLoading="false" @getSelectValue="getSelectCourse" label="name" value="code" :list="CourseOptions" :isMultiple="false" :paginationOption="paginationOptionCourse" />
                <el-input v-else :disabled="courseDisabled" v-model="defaultCourseValue" maxlength="100"></el-input>
            </el-form-item>
        </div>
        <div class="formItemBox mb-15">
            <el-form-item label="授课课时" prop="periodcount">
                <el-input v-model="form.periodcount" maxlength="100"  placeholder="授课课时"></el-input>
            </el-form-item>
        </div>
        <div class="formItemBox mb-15">
            <el-form-item label="开始上课日期" prop="begindate">
                <el-date-picker
                    value-format="yyyy-MM-dd"
                    v-model="form.begindate"
                    type="date"
                    placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
        </div>
        <div class="formItemBox setTimeBtnBox mb-15">
            <el-form-item label="上课时间" prop="schooltime">
                <el-select @change="getTimes" v-model="timeArr" multiple placeholder="请选择">
                    <el-option
                    v-for="item in timeOptions"
                    :key="item.code"
                    :label="item.timeStr"
                    :value="item.code">
                    </el-option>
                </el-select>
            </el-form-item>
            <div class="setTimeBtn" @click="handleOpenSelectTime">设置上课时间</div>
        </div>
        <div class="formItemBox mb-15">
            <el-form-item label="重复方式" prop="reway">
                    <el-radio v-model="form.reway" label="0">单次</el-radio>
                    <el-radio v-model="form.reway" label="1">循环周期</el-radio>
            </el-form-item>
        </div>
        <div class="formItemBox mb-15" v-if="form.reway == 1">
            <el-form-item label="循环周期" prop="cycletime">
                <div class="weekContent flex">
                    <span @click="choose(item)" :class="item.isCheck?'activeItem':''" class="item" v-for="item in weekData" :key="item.value">{{item.label}}</span>
                </div>
            </el-form-item>
        </div>
        <div class="formItemBox mb-15">
            <el-form-item label="课次截止" prop="periodendtype">
                <el-radio v-model="form.periodendtype" label="0">按总课时</el-radio>
                <el-radio v-model="form.periodendtype" label="1">设置结束日期</el-radio>
            </el-form-item>
        </div>
        <div class="formItemBox mb-15" v-if="form.periodendtype == 1">
            <el-form-item label="结束日期" prop="enddate">
                <el-date-picker
                    value-format="yyyy-MM-dd"
                    v-model="form.enddate"
                    type="date"
                    placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
        </div>
        <div class="formItemBox mb-15">
            <el-form-item label="授课老师" prop="teachername">
                <SelectPage ref="SelectPageTeach" :listLoading="false" @getSelectValue="getSelectValue" label="orgname" value="code" :list="teachOptions" :isMultiple="true" :paginationOption="paginationOption" />
            </el-form-item>
        </div>
        <div class="formItemBox mb-15">
            <el-form-item label="授课内容" prop="">
                <el-input
                    type="textarea"
                    :rows="2"
                    maxlength="200"
                    placeholder="请输入内容"
                    v-model="form.name">
                </el-input>
            </el-form-item>
        </div>
        <AddTimeConfig ref="AddTimeConfig" @saveSuccess="saveSuccess"/>
    </el-form>
</template>
<script>
import {saveRuleCourse,getTeacherList,getCourseList, getClassListBySelect,getTimeconfigList} from '@/api/measApi/teachManagement.js'
import {getTableDefaultPageSize} from '@/assets/measAssets/js/tools.js'
import SelectPage from '@/components/measComponents/selectPage/selectPage'
import AddTimeConfig from '@//views/meas/systemManage/timeConfig/components/addTimeConfig'
export default {
    
    data(){
        return {
            defaultForm: {},
            form: {
                begindate: '',
                classcoursecode: '',
                cycletime: '',
                enddate: '',
                periodcount: '',
                periodendtype: '',
                reway: '',
                schooltime: [],
                teachercode: '',
                teachername: ''
            },
            weekData: [
                {label: '周一', value: 1, isCheck: false},
                {label: '周二', value: 2, isCheck: false},
                {label: '周三', value: 3, isCheck: false},
                {label: '周四', value: 4, isCheck: false},
                {label: '周五', value: 5, isCheck: false},
                {label: '周六', value: 6, isCheck: false},
                {label: '周日', value: 7, isCheck: false},
            ],
            rules: {
                classcoursecode: [
                    { required: true, message: '请选择', trigger: 'blur' }
                ],
                periodcount: [
                    { required: true, message: '请输入', trigger: 'blur' }
                ],
                begindate: [
                    { required: true, message: '请选择', trigger: 'blur' }
                ],
                schooltime: [
                    { required: true, message: '请选择', trigger: 'blur' }
                ],
                reway: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                cycletime: [
                    { required: true, message: '请选择', trigger: 'blur' }
                ],
                periodendtype: [
                    { required: true, message: '请选择', trigger: 'blur' }
                ],
                enddate: [
                    { required: true, message: '请选择', trigger: 'blur' }
                ],
                // teachername: [
                //     { required: true, message: '请选择', trigger: 'blur' }
                // ],
            },
            classParams: {
                condition: {
                    keyword: '',
                    status: 10,
                    ispaging: true
                },
                page: 1,
                pagesize:  5
            },
            classOptions: [],
            CourseOptions:[],
            paginationOptionClass: {
                pagesize: getTableDefaultPageSize(),
                page: 1,
                total: 0
            },
            paginationOption: {
                pagesize: getTableDefaultPageSize(),
                page: 1,
                total: 0
            },
            paginationOptionCourse: {
                pagesize: getTableDefaultPageSize(),
                page: 1,
                total: 0
            },
            timeParams: {
                condition: {
                    description: ''
                },
                orderbyname: '',
                orderbyorder: '',
                page: 1,
                pagesize: getTableDefaultPageSize()
            },
            timeOptions: [],
            timeArr: [],
            classCourseParams: {
                condition: {
                    classcode: '',
                    classname: '',
                    status: 10,
                    name: ''
                }
            },
            teachParams: {
                condition: {
                    innerid: '',
                    orgname: ''
                },
                orderbyname: '',
                orderbyorder: '',
                page: 1,
                pagesize: getTableDefaultPageSize()
            },
            teachOptions:[],
            initDate:[],
            disabled: false,
            courseDisabled: false,
            defaultChoiceValue: '',//传入的班级名称
            defaultCourseValue: ''//传入的课程名称
        }
    },
    props: {
        classCode: {
            type: String,
        },
        className: {
            type: String
        },
        classCourseCode: {
            type: String
        },
        classCourseName: {
            type: String
        }
    },
    watch: {
        classCode: {
            handler(newVal){
                if(newVal){
                    this.disabled = true
                    this.form.classcoursecode = newVal
                    this.classCourseParams.condition.classcode = newVal
                    this.getCourseList()
                }
            },
            immediate: true
        },
        classCourseCode: {
            handler(newVal){
                if(newVal){
                    this.courseDisabled = true
                    console.log( this.courseDisabled,' this.courseDisabled')
                    this.form.classcoursecode = newVal
                }
            },
            immediate: true
        },
        className: {
            handler(newVal){
                if(newVal){
                    this.defaultChoiceValue = newVal
                }
            },
            immediate: true
        },
        classCourseName: {
            handler(newVal){
                if(newVal){
                    this.defaultCourseValue = newVal
                    console.log(this.defaultCourseValue,'newVal')
                }
            },
            immediate: true
        }
    },
    components: {
        SelectPage,
        AddTimeConfig
    },
    created(){
        // this.init()
    },
    methods: {
        init(){
            this.form.classcoursecode = ''
            this.$refs.form.resetFields()
            if(!this.disabled){
                this.$refs.SelectPage.choiceValue = {}
                this.$refs.SelectPageCourse.choiceValue = {}
                this.$refs.SelectPageTeach.choiceValue = []
            }
            this.timeArr = []
            this.getClassListBySelect()
            this.getTimeconfigList()
            this.getTeacherList()
        },
        //设置上课时间
        handleOpenSelectTime(){
            this.$refs.AddTimeConfig.handleOpen()
        },
        saveSuccess(){
            this.getTimeconfigList()
        },
        // 班级下拉获取
        getClassListBySelect(){
            getClassListBySelect(Object.assign(this.classParams, this.paginationOptionClass)).then(res => {
                console.log('GGGGGG')
                this.classOptions = res.data
                this.paginationOptionClass.total = res.pageinfo.rowcount
                console.log(res,'班级下拉')
            })
        },
        // 获取选择的班级code
        // getClassCode(value){
        //     this.form.classcoursecode = value
        //     this.classCourseParams.condition.classcode = value
        //     this.getCourseList()
        //     console.log(value)
        // },
        // 获取班级课程下拉
        getCourseList(){
            getCourseList(Object.assign(this.classCourseParams, this.paginationOptionCourse)).then(res => {
                console.log(res,'班级课程下拉')
                this.CourseOptions = res.data
                this.paginationOptionCourse.total = res.pageinfo.rowcount
            })
        },
        getSelectCourse(value){
            this.form.classcoursecode = value[0].code
        },
        getSelectClass(value){
            // this.classParams.condition.keyword = value[0].code
            this.form.classcoursecode = value[0].code
            this.classCourseParams.condition.classcode = value[0].code
            this.getCourseList()
        },
        // 获取时间段下拉
        getTimeconfigList(){
            getTimeconfigList(this.timeParams).then(res => {
                console.log(res,'时间段下拉')
                let arr = JSON.parse(JSON.stringify(res.data))
                arr.forEach(element => {
                    element.timeStr = element.starttime+'-'+element.endtime
                });
                this.timeOptions = arr
            })
        },
        getTimes(code){
            console.log(code,'code')
            let arr = []
            this.timeOptions.forEach(item => {
                code.forEach(itm => {
                    if(item.code === itm){
                        arr.push({
                            starttime: item.starttime,
                            endtime: item.endtime
                        })
                    }
                })
                
            })
            this.form.schooltime = arr
        },
        // 获取老师下拉
        getTeacherList(){
            getTeacherList(Object.assign(this.teachParams,this.paginationOption)).then(res => {
                this.teachOptions = res.data
                this.paginationOption.total = res.pageinfo.rowcount
                console.log(res,'老师')
            })
        },
        // 获取老师code
        getSelectValue(value){
            let arrName = []
            let arrCode = []
            value.forEach(item => {
                arrName.push(item.orgname)
                arrCode.push(item.code)
            })
            this.form.teachercode = arrCode.toString()
            this.form.teachername = arrName.toString()
        },
        handleCloses(){
            this.weekData.forEach(item => {
                item.isCheck = false
            })
            // this.form.classcoursecode = ''
            this.form = JSON.parse(JSON.stringify(this.defaultForm))
            // this.$refs.form.resetFields()
            this.classParams.condition.keyword = ''
        },
        changeModel(activeName){
            this.activeName = activeName
        },
        choose(item){
            item.isCheck = !item.isCheck
            let arr = []
            this.weekData.map(item => {
                if(item.isCheck){
                    arr.push(item.value)
                }
            })
            this.form.cycletime = arr.toString()
        },
        submit(formName){
            console.log(this.form,'this.form')
             this.$refs[formName].validate((valid) => {
            if (valid) {
                    this.saveRuleCourse(formName)
                } else {
                    return false;
                }
            });
        },
        saveRuleCourse(formName){
            saveRuleCourse(this.form).then(res => {
                if(res.code === '000'){
                    this.$refs[formName].resetFields();
                    this.$message.success(res.msg)
                    this.handleCloses()
                    this.$emit('handleClose1')
                }else{
                    this.$message.error(res.msg)
                }
            })
        }
    }
        
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body{
    padding: 0!important;
}
.setTimeBtnBox{
    align-items: flex-end!important;
}
.setTimeBtn{
    height: 36px;
    background: #0B75FA;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    padding: 0 20px;
    cursor: pointer;
}
.scheduleConte{
    .weekContent{
        align-items: center;
        // border-right: 1px solid #EAEAEA;
        .item{
            text-align: center;
            font-size: 14px;
            color: #666666;
            height: 32px;
            width: 68px;
            border: 1px solid #EAEAEA;
            cursor: pointer;
        }
        .activeItem{
            border: 1px solid #409EFF;
            color: #409EFF;
        }
    }
    >.el-scrollbar__wrap{
        padding: 0!important;
    }
    .modelBox{
        background: #F6F7FB;
        height: 44px;
        color: #666666;
        font-size: 14px;
        line-height: 44px;
        .gzModel,.dateMode{
            padding: 0 20px;
            cursor: pointer;
        }
        .activeModel{
            background: white;
        }
    }
    .formContent{
        padding: 20px;
    }
}
</style>